import { useCallback } from "react"
import { IExportLayout, ILayoutColumn } from "../../application/models"
import { useAxiosInstances } from "../axios-instance"

export const useExportLayoutApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()


  const findExportLayoutByCompanyId = useCallback((data: {
    companyId: string
  }): Promise<IExportLayout[]> => {
    return axiosAuthInstance.get('/routes/export-layout/company-layouts', {
      params: {
        ...data
      }
    }).then((response) => {
      const result = response.data.result.exportLayoutList
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    })
  }, [axiosAuthInstance])


  const updateExportLayoutApi = useCallback((data: {
    id?: string,
    name?: string,
    layoutColumns?: ILayoutColumn[],
    modelId?: string // Adicione esta linha
  }): Promise<IExportLayout> => {
    return axiosAuthInstance.put('/routes/export-layout', {
      exportLayoutData: {
        ...data
      }
    }).then((response) => {
      const result = response.data.result.exportLayout
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    }).catch((err) => {
    })
  }, [axiosAuthInstance])

  const createExportLayoutApi = useCallback((data: {
    exportLayout: {
      companyId?: string,
      name?: string,
      layoutColumns?: ILayoutColumn[]
      createdBy?: string
      modelId?: string
    }
  }): Promise<IExportLayout> => {
    return axiosAuthInstance.post('/routes/export-layout', {
      ...data.exportLayout

    }).then((response) => {
      const result = response.data.result.exportLayout
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    }).catch((err) => {
    })
  }, [axiosAuthInstance])

  const deleteExportLayoutApi = useCallback((data: {
    id?: string
  }): Promise<IExportLayout> => {
    return axiosAuthInstance.delete('/routes/export-layout/' + data.id).then((response) => {
      const result = response.data.result.exportLayout
      if (result) {
        return result
      } else {
        throw new Error('No result')
      }
    }).catch((err) => {
    })
  }, [axiosAuthInstance])

  const duplicateExportLayoutApi = useCallback((data: {
    companyId: string
    userId: string
    name: string
  }): Promise<IExportLayout> => {
    return axiosAuthInstance
      .post('/routes/export-layout/duplicate', data)
      .then(res => {
        const dup = res.data.result.duplicatedLayout
        if (dup) return dup
        throw new Error('No duplicated layout')
      })
  }, [axiosAuthInstance])



  return {
    duplicateExportLayoutApi,
    findExportLayoutByCompanyId,
    updateExportLayoutApi,
    createExportLayoutApi,
    deleteExportLayoutApi
  }
}